import React, { createContext, useMemo, useState } from 'react'

const defaultValues = {
  globalNavActive: false,
  isSubMenuActive: false,
  ToggleGlobalNav: () => {},
  pageHasScrolled: false,
  setpageHasScrolled: () => {},
  closeSubMenu: () => {},
  openSubMenu: () => {},
  closeFirstMenu: () => {},
  CloseAll: () => {},
}

export const AppContext = createContext(defaultValues)

export function AppProvider({ children }) {
  const [globalNavActive, setGlobalNavActive] = useState(defaultValues.globalNavActive)
  const [isSubMenuActive, setIsSubMenuActive] = useState(defaultValues.isSubMenuActive)
  const [pageHasScrolled, setpageHasScrolled] = useState(defaultValues.pageHasScrolled)

  const ToggleGlobalNav = (isSubMenu, isMegaMenu) => {
    if (!isSubMenu) {
      setGlobalNavActive(!globalNavActive)

      return
    }

    if (isMegaMenu) {
      setGlobalNavActive(!globalNavActive)
      setIsSubMenuActive(!isSubMenuActive)
    } else {
      if (isSubMenuActive && !globalNavActive) {
        setGlobalNavActive(true)
      }

      if (isSubMenuActive && globalNavActive) {
        setGlobalNavActive(false)
        setIsSubMenuActive(false)
      }

      if (!isSubMenuActive && !globalNavActive) {
        setIsSubMenuActive(true)
      }
    }
  }

  const CloseAll = () => {
    setGlobalNavActive(false)
    setIsSubMenuActive(false)
  }

  const closeFirstMenu = () => {
    setGlobalNavActive(false)
    setIsSubMenuActive(true)
  }

  const openSubMenu = () => {
    setIsSubMenuActive(true)
  }

  const closeSubMenu = () => {
    setIsSubMenuActive(false)
  }

  const value = useMemo(
    () => ({
      ...defaultValues,
      globalNavActive,
      isSubMenuActive,
      ToggleGlobalNav,
      pageHasScrolled,
      setpageHasScrolled,
      closeSubMenu,
      openSubMenu,
      closeFirstMenu,
      CloseAll,
    }),
    [
      globalNavActive,
      isSubMenuActive,
      ToggleGlobalNav,
      pageHasScrolled,
      setpageHasScrolled,
      closeSubMenu,
      openSubMenu,
      closeFirstMenu,
      CloseAll,
    ]
  )

  return (
    <AppContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={value}
    >
      {children}
    </AppContext.Provider>
  )
}
